'use client';

import Script from 'next/script';

interface AhrefsAnalyticsProps {
  token: string;
}

export default function AhrefsAnalytics({ token }: AhrefsAnalyticsProps) {
  if (!token) {
    return null;
  }

  return (
    <Script
      id="ahrefs-analytics"
      src="https://analytics.ahrefs.com/analytics.js"
      data-key={token}
      strategy="lazyOnload"
    />
  );
}
